import VariationEditForm from "./variation-edit-form";

const VariationForms = {
  Edit: VariationEditForm,
};

export default VariationForms;
